export const apartments = {
  list: [],
  onPage: [],
	hidden: [],
  container: "Not loaded yet",
	currentFilters: {},
	callbacks: [],
	lastElement: null,
	addMoreButton: "Not loaded yet",
	init: function () {
		this.container = document.querySelector("#apartamentsList");
		this.addMoreButton = this.container.querySelector(".load-more")
		this.list.push(...this.container.querySelectorAll(".element"));
		this.onPage.push(...this.container.querySelectorAll(".element"));

		this.callbacks.forEach((cb)=>{
			try{
				cb();
			}catch(e){
				console.error(e)
			}
		})
		return this;
	},
  count: function () {
    return this.list.length;
  },
  add: function (apartment) {
    this.list.push(apartment);
    return this;
  },
  removeAllOnPage: function () {
    this.onPage = [];
		this.container.querySelectorAll(".element").forEach((el)=>{
			el.remove();
		})
    return this;
  },
  addOnPage: function (apartment = this.lastElement) {
		if(typeof apartment.length !== 'undefined'){
			apartment.forEach(e=>{
				this.onPage.push(e);
			this.container.append(e);
			})
		}else{
			this.onPage.push(apartment);
			this.container.append(apartment);
		}
    return this;
  },
	afterInit: function(callback){
		this.callbacks.push(callback);
		return this
	},
  template: function ({ images: { small = "", big = "" } = {}, text = {} } = {}) {
    const element = `
			<div class="element">
				<div class="text">
				</div>
				<div class="image-thumb--small">
					<img src="${small}" alt="Small apartment image">
				</div>
				<div class="image-thumb--big">
					<img src="${big}" alt="Big apartment image">
				</div>
			</div>
		`;
		const parser = new DOMParser();
		const doc = parser.parseFromString(element, "text/html");
		const output = doc.body.firstChild;
		let list = []
		const d = {
			'area': "Площа",
			'rooms': "Кімнати",
			'floor': "Поверх",
			'section': "Секція",
		}
		Object.keys(text).forEach((key = '')=>{
			const p = document.createElement('p');
			p.innerHTML = d[key]
			const h6 = document.createElement('h6');
			h6.innerHTML = text[key]
			const punct = document.createElement('div');
			punct.append(p)
			punct.append(h6)
			punct.classList.add('punct')
			list.push(punct)
		})
		output.querySelector('.text').append(...list)
		this.lastElement = output;
    return output;
  },
	setFilter: function(name, filters){
		this.currentFilters[name] = filters;
		return this;
	},
	getFilter: function(name){
		return this.currentFilters[name];
	},
	clearFilters: function(){
		this.currentFilters = {};
		return this;
	},
	emptyFilters: function(){
		return Object.keys(this.currentFilters).length === 0;
	},
	addMore: {
		spawn: function(){
			if(apartments.container.querySelector(".load-more")) return;
			apartments.container.append(apartments.addMoreButton);
		},
		remove: function(){
			apartments.container.querySelector(".load-more")?.remove();
		}
	},
	addHidden: function(apartment){
		this.hidden.push(apartment);
		return this;
	},
	getHidden: function(count){
		return this.hidden.splice(0, count);
	}
};